export const NEWS_PER_PAGE = 6;
export const MATTERS_PER_PAGE = 10;
export const CATEGORIES_PER_PAGE = 8;
export const FORUM_TOPICS_PER_PAGE = 10;
